var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9083 11.5733H20.9583V6.85107H9.5583V11.5733H8.6083C7.0313 11.5733 5.7583 12.8389 5.7583 14.4066V20.0733H9.5583V23.8511H20.9583V20.0733H24.7583V14.4066C24.7583 12.8389 23.4853 11.5733 21.9083 11.5733ZM11.4583 8.73996H19.0583V11.5733H11.4583V8.73996ZM19.0583 21.9622H11.4583V18.1844H19.0583V21.9622ZM20.9583 18.1844V16.2955H9.5583V18.1844H7.6583V14.4066C7.6583 13.8872 8.0858 13.4622 8.6083 13.4622H21.9083C22.4308 13.4622 22.8583 13.8872 22.8583 14.4066V18.1844H20.9583Z",
    fill: "#214ba5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.af464175b7d9a689041794f0b085f2e5.svg";
export { ForwardRef as ReactComponent };